import React, { useState } from 'react';
import { toast } from 'sonner';
import { apiPost } from '../../../api/client';
import { Button } from '../../../components/ui/Button';
import { Section } from '../../../components/ui/Section';

export default function CalendarMaintenanceSection() {
  const [syncing, setSyncing] = useState(false);

  const handleForceSync = async () => {
    if (!confirm('Sincronizzare TUTTI gli eventi di TUTTI gli utenti con Google Calendar? Questa operazione può richiedere alcuni minuti.')) return;
    setSyncing(true);
    try {
      const res = await apiPost<{ total?: number; synced?: number; created?: number; updated?: number; errors?: string[] }>(
        '/user-settings/admin/gcal-sync', {}
      );
      const synced = res?.synced ?? 0;
      const created = res?.created ?? 0;
      const updated = res?.updated ?? 0;
      const errors = res?.errors ?? [];
      toast.success(`Sync completata: ${synced} eventi (${created} creati, ${updated} aggiornati)${errors.length ? `, ${errors.length} errori` : ''}`);
      if (errors.length > 0) {
        console.warn('Force sync errors:', errors.slice(0, 5));
      }
    } catch (e: unknown) {
      toast.error(`Errore sync: ${(e as Error).message}`);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Section title="Manutenzione Calendar">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
          Forza la sincronizzazione di tutti gli eventi verso Google Calendar.
          Gli eventi già sincronizzati vengono aggiornati, quelli nuovi vengono creati.
        </p>
        <Button variant="secondary" onClick={handleForceSync} loading={syncing}>
          Sincronizza tutti gli eventi
        </Button>
      </div>
    </Section>
  );
}
